import {Injectable} from "@angular/core";
import {debounceTime, Observable, Subject} from "rxjs";

@Injectable()
export class FUIPopsService {
    private _pop: number;
    public $pop: Subject<number>;
    public pop$: Observable<number>;

    constructor() {
        this.$pop = new Subject<number>();
        this.pop$ = this.$pop.asObservable().pipe(debounceTime(0));
    }

    /**
     *
     * @returns {number}
     */
    public get pop(): number {
        return this._pop;
    }

    /**
     *
     * @param {number} pop
     */
    public set pop(pop: number) {
        if (this._pop !== pop) {
            this._pop = pop;
            this.$pop.next(this.pop);
        }
    }
}
